import { RouteFieldTesterSuggestionDTO } from 'api/model';

/**
 * Vilka hemankare kandidatens dag börjar och slutar vid, som en rad för paketkortet och
 * bytesmodalen.
 *
 * En fälttestare kan ha flera ankare (typfallet hubb + centralstation), och planeringen väljer
 * start och slut var för sig som det närmaste — så en dag kan börja vid hubben och sluta vid
 * stationen. Då visas båda ("Zäkra Hub Jakobsberg → Stockholm C"); är de samma visas ett, som
 * förut. Utan ankare faller raden tillbaka på folkbokföringsorten.
 *
 * `homeAnchorName` är reserven för ett svar från en backend före flera ankare: där finns bara det.
 */
const formatCandidateAnchors = (
  candidate: Pick<
    RouteFieldTesterSuggestionDTO,
    | 'startAnchorName'
    | 'startAnchorCity'
    | 'endAnchorName'
    | 'homeAnchorName'
    | 'homeAnchorCity'
    | 'homeCity'
  >
): string => {
  const startName = candidate.startAnchorName ?? candidate.homeAnchorName;
  const startCity = candidate.startAnchorCity ?? candidate.homeAnchorCity;

  if (!startName) {
    return `Hem · ${candidate.homeCity || '—'}`;
  }

  const endName = candidate.endAnchorName;
  if (endName && endName !== startName) {
    return `${startName} → ${endName}`;
  }

  return startCity ? `${startName} · ${startCity}` : startName;
};

export default formatCandidateAnchors;
